import moment from "moment";
import imagefileicon from "../../chat-components/Chat-component/EmailBodyComponent/EmailAsset/img.png";
import videofileicon from "../../chat-components/Chat-component/EmailBodyComponent/EmailAsset/video.png";
import textfileicon from "../../chat-components/Chat-component/EmailBodyComponent/EmailAsset/txt.png";
import pdffileicon from "../../chat-components/Chat-component/EmailBodyComponent/EmailAsset/pdf.png";
import docfileicon from "../../chat-components/Chat-component/EmailBodyComponent/EmailAsset/doc.png";
import xlfileicon from "../../chat-components/Chat-component/EmailBodyComponent/EmailAsset/xl.png";

export const fileTypeToIcon = {
  plain: textfileicon,
  xlsx: xlfileicon,
  mp4: videofileicon,
  pdf: pdffileicon,
  docx: docfileicon,
  png: imagefileicon,
  jpeg: imagefileicon,
  mpeg: imagefileicon,
};

export const fileTypeToIconNeMail = {
  txt: textfileicon,
  xlsx: xlfileicon,
  mp4: videofileicon,
  pdf: pdffileicon,
  docx: docfileicon,
  jpg: imagefileicon,
  png: imagefileicon,
  plain: textfileicon,
  mpeg: imagefileicon,
};

export const formatFileSize = (sizeInBytes) => {
  if (!sizeInBytes) return;

  const fileSizeInKB = sizeInBytes / 1024;
  const formattedSize =
    fileSizeInKB >= 1024
      ? `${(fileSizeInKB / 1024).toFixed(2)} MB`
      : `${fileSizeInKB.toFixed(2)} KB`;

  return formattedSize;
};

export const regixToEmailAddress = (value) => {
  if (!value) return;

  // const match = value.match(/<([^>]+)>/);
  // if (match && match[1]) {
  //   const email = match[1];
  //   return [{ label: email, value: email }];
  // } else {
  return [{ label: value, value: value }];
  // }
};

export const regixCcEmailAddress = (value) => {
  if (!value) return;
  console.log("regixCcEmailAddress", value);
  const emailAddresses = value.map((item) => {
    // const match = item.find(/<([^>]+)>/);
    // if (match && match[1]) {
    //   const email = match[1];
    //   return {
    //     value: email,
    //     label: email,
    //   };
    // } else {
    return {
      label: item.emailAddress.address,
      value: item.emailAddress.address,
    };
    // }
  });
  return emailAddresses;
};

export const regixBccEmailAddress = (value) => {
  if (!value) return;
  const emailAddresses = value.map((item) => {
    // const match = item.match(/<([^>]+)>/);
    // if (match && match[1]) {
    //   const email = match[1];
    //   return {
    //     value: email,
    //     label: email,
    //   };
    // } else {
    return {
      label: item.emailAddress.address,
      value: item.emailAddress.address,
    };
    // }
  });
  return emailAddresses;
};
